"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageProgressDetails = void 0;
/* Package Imports */
var filesize_1 = __importDefault(require("filesize"));
var moment_1 = __importDefault(require("moment"));
var react_1 = __importDefault(require("react"));
// import ProgressTimer from 'react-progress-timer';
/* Blast Imports */
var utils_1 = require("@app/shared/utils");
/**
 * Display the specific details of a transfer's progress
 *  - completion percentage
 *  - amount of bytes transferred
 *  - estimated time remaining
 */
var PackageProgressDetails = function (props) {
    var timeRemainingElement = null;
    if (props.percent && props.start_time && props.stop_time) {
        var startedSecsAgo = moment_1.default(moment_1.default.now()).diff(moment_1.default(props.start_time), 'seconds');
        var diff = moment_1.default(props.stop_time).diff(moment_1.default(props.start_time), 'seconds');
        var percentageLeft = 100 - Number(props.percent);
        var timeRemaining = ((diff / Number(props.percent)) * percentageLeft);
        if (startedSecsAgo > 30) {
            timeRemainingElement = react_1.default.createElement("p", null, moment_1.default.duration(timeRemaining, 'seconds').humanize() + " remaining");
        }
        else {
            timeRemainingElement = react_1.default.createElement("p", null, "Initializing");
        }
    }
    // const progressTimer = <ProgressTimer
    //     format={'{value} {unit} remaining'}
    //     percentage={props.percent}
    // />;
    return (react_1.default.createElement("div", { className: "package-progress-details help" },
        react_1.default.createElement("p", null, (props.percent) ? utils_1.getPercentComplete(props.percent, 100) : utils_1.getPercentComplete(props.transferredBytes, props.totalBytes)),
        react_1.default.createElement("p", null, filesize_1.default(props.transferredBytes)),
        timeRemainingElement));
};
exports.PackageProgressDetails = PackageProgressDetails;
